const RECENT_EMOJI_STORAGE_KEY = "recent_emojis";
const MAX_RECENT_EMOJIS = 30;

const isBrowser = (): boolean => typeof window !== "undefined";

export const loadRecentEmojis = (): string[] => {
  if (!isBrowser()) return [];

  try {
    const raw = window.localStorage.getItem(RECENT_EMOJI_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((item): item is string => typeof item === "string");
  } catch {
    return [];
  }
};

export const saveRecentEmoji = (emoji: string): string[] => {
  const next = [emoji, ...loadRecentEmojis().filter((item) => item !== emoji)]
    .slice(0, MAX_RECENT_EMOJIS)
    .filter(Boolean);

  if (!isBrowser()) return next;

  try {
    window.localStorage.setItem(RECENT_EMOJI_STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage failures (private mode, quota, etc.).
  }

  return next;
};
